import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const RconHero = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <div className="rcon-hero-wrap">
      <h1 className="rcon-hero-title">
        RCON <span className="rcon-hero-title-accent">AUDIT</span>
      </h1>

      <p className="rcon-hero-subtitle">
        {isEn
          ? 'Scanning open RCON ports and brute-forcing passwords using complex dictionaries. Connect to the server below.'
          : 'Сканирование открытых портов RCON и попытка подбора паролей с помощью комплексных словарей. Подключитесь к серверу ниже.'}
      </p>
    </div>
  );
};

export default RconHero;
